import router from '@/router'
import { Posts } from '@/services/PostsDataService'
import { Options, Vue } from 'vue-class-component'
import LeftSideBar from '../LeftSideBar/index.vue'
import { useRoute } from 'vue-router'

@Options({
  components: {
    LeftSideBar
  }
})
export default class NewsCategory extends Vue {
  private posts: any[] = []
  private currentPage: any = 1
  public totalCount: any = 3

  public getPosts () {
    return this.posts
  }

  public getCurrentPage () {
    return this.currentPage
  }

  public paginationView () {
    if (this.totalCount <= 5) {
      return Array.from({ length: this.totalCount }, (_, i) => i + 1)
    } else if (this.currentPage === 1) {
      return [1, 2, 3, '...', this.totalCount]
    } else if (this.currentPage === 2) {
      return [1, 2, 3, 4, '...', this.totalCount]
    } else if (this.currentPage === 3) {
      return [1, 2, 3, 4, 5, '...', this.totalCount]
    } else if (this.currentPage > 3 && this.currentPage < this.totalCount - 2) {
      return [1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalCount]
    } else if (this.currentPage >= this.totalCount - 2) {
      return [1, '...', this.totalCount - 4, this.totalCount - 3, this.totalCount - 2, this.totalCount - 1, this.totalCount]
    }
    return []
  }

  public setCurrentPage (currPage:any) {
    const page = Number(currPage)
    if (page >= 1 && page <= this.totalCount) {
      this.currentPage = page
    }
  }

  public viewPostById (item: any) {
    if (!item) return
    this.$router.push({
      name: 'Indlaeg_type',
      params: { indlaeg_type: item?.indlaeg_kategori_id?.indlaeg_kategori_titel, indlaegSlug: item.indlaeg_slug }
    })
  }

  goToAuthorPosts (authorName: string) {
    this.$router.push({
      name: 'Author',
      params: { author_name: authorName }
    })
  }

  goToCategories (categoryType:any, e:any) {
    e.stopPropagation()
    this.$router.push({
      name: 'category',
      params: { categoryType: categoryType }
    })
  }

  public showPostPageWise () {
    return this.posts.slice((5 * (this.currentPage - 1)), (5 * this.currentPage))
  }

  public getBreadcrumbs (): Record<string, string>[] {
    const route = useRoute()
    const fullPath = route.path
    const segments = fullPath.split('/').filter(seg => seg)

    const breadcrumbs = segments.map((seg, index) => {
      return {
        name: seg.charAt(0).toUpperCase() + seg.slice(1),
        path: '/' + segments.slice(0, index + 1).join('/')
      }
    })

    return [...breadcrumbs]
  }

  public getCategoryWisePosts () {
    return this.posts.filter(
      (post: any) =>
        post?.indlaeg_kategori_id?.indlaeg_kategori_titel ===
        router.currentRoute.value.params.categoryType
    ).slice(0, 7)
  }

  extractImgUrl (content: any) {
    const html = content?.indlaeg_versionerings_id?.[content?.indlaeg_versionerings_id.length - 1]?.indlaeg_versionering_indhold ?? ''
    const urls = new Set()

    const combinedRegex = /<img[^>]+src=["']([^"']+\.(?:jpg|jpeg|png|gif|webp|svg))["']|https?:\/\/[^\s"'<>]+?\.(?:jpg|jpeg|png|gif|webp|svg)/gi
    let match

    while ((match = combinedRegex.exec(html)) !== null) {
      urls.add(match[1] || match[0])
    }
    const res = Array.from(urls)[0]
    return res
  }

  formatDate (isoDate: string): string {
    const date = new Date(isoDate)
    const options = { month: 'long', day: 'numeric', year: 'numeric' }
    return date.toLocaleDateString('en-US', options)
  }

  public async getData (): Promise<void> {
    try {
      const response = await Posts.PostsDataService.getPopulatedData()
      if (response?.data) {
        this.posts = response.data
        this.totalCount = Math.ceil(response.data.length / 5)
      }
    } catch (error) {
      console.error('Failed to fetch indlaegs data', error)
    }
  }

  mounted (): void {
    this.getData()
  }

  public dynamicClass (index: number): string {
    const classMap = ['one', 'two', 'three', 'four', 'five', 'six', 'seven']
    return classMap[index] || 'default'
  }
}
